module.exports = __webpack_public_path__ + "static/SymbolSync2x-a467f739d555e13a668d1003cf0e9fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-zeplin/SymbolSync2x.jpg
// module id = 2669
// module chunks = 21098653631116